import { Suspense, lazy } from "react"

const isProd = process.env.NODE_ENV === "production"

const DevTools = isProd
  ? () => null
  : lazy(() =>
      import("./DevTools").then((res) => ({
        default: res.LazyDevTools,
      })),
    )

export const AppDevTools = () =>
  isProd ? null : (
    <Suspense fallback={null}>
      <DevTools />
    </Suspense>
  )
